import Button from '@atoms/Button';
import { StyledInput } from '@atoms/Input/Input.styled';
import { INPUT_TYPE } from '@atoms/Input/Input.types';
import type { ReactElement } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import {
  ErrorMessage,
  FieldsWrapper,
  Form,
  FormWrapper,
  MessageWrapper,
  SubmitButtonWrapper,
  TextArea,
} from './ContactForm.styled';

export const ContactForm = (): ReactElement => {
  const [status, setStatus] = useState<string | null>(null);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const submitForm = async data => {
    setStatus('🚀 Wysyłam wiadomość...');

    try {
      const res = await fetch('/api/send-contact-form', {
        body: JSON.stringify(data),
        method: 'POST',
      });
      if (res.status == 200) {
        setStatus('✅ Udało się! Dzięki za kontakt.');
      } else {
        setStatus('❌ Coś poszło nie tak. Spróbuj ponownie.');
      }
    } catch (error) {
      setStatus('❌ Coś poszło nie tak. Spróbuj ponownie.');
    }
  };

  const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i;

  return (
    <FormWrapper>
      <h2>🤙 Formularz kontaktowy</h2>
      <p>Masz pytania? Napisz. 🤓</p>
      <Form onSubmit={handleSubmit(submitForm)}>
        <FieldsWrapper>
          <label htmlFor="nameInput">
            <span>Imię</span>
            <StyledInput
              {...register('nameInput', { required: true, minLength: 2 })}
              id="nameInput"
              placeholder="Imię"
              type={INPUT_TYPE.TEXT}
              aria-invalid={errors.nameInput ? 'true' : 'false'}
            />
            {errors.nameInput && (
              <ErrorMessage className="error">Podaj swoje imię</ErrorMessage>
            )}
          </label>
          <label htmlFor="emailInput">
            <span> Email</span>
            <StyledInput
              {...register('emailInput', {
                required: true,
                pattern: EMAIL_REGEX,
              })}
              id="emailInput"
              placeholder="Email"
              type={INPUT_TYPE.EMAIL}
              aria-invalid={errors.emailInput ? 'true' : 'false'}
            />
            {errors.emailInput && (
              <ErrorMessage className="error">
                Podaj poprawny adres e-mail
              </ErrorMessage>
            )}
          </label>
          <label htmlFor="messageInput">
            <span>Wiadomość</span>
            <TextArea
              {...register('messageInput', { required: true, minLength: 10 })}
              id="messageInput"
              placeholder="Wiadomość"
              rows={12}
              aria-invalid={errors.messageInput ? 'true' : 'false'}
            />
            {errors.messageInput && (
              <ErrorMessage className="error">
                Napisz min. 10 znaków
              </ErrorMessage>
            )}
          </label>
          <SubmitButtonWrapper>
            <Button>Wyślij</Button>
          </SubmitButtonWrapper>
          {status && <MessageWrapper>{status}</MessageWrapper>}
        </FieldsWrapper>
      </Form>
    </FormWrapper>
  );
};
